export default __webpack_public_path__ + "static/pancakeswap-2bfbc8e4f080f2ccec15fd9ab02e8ec1.svg";